import supabase from '@/api/supabase/index'
import { STORES_META } from '@/store/index'

// Shared deal/store loading helpers. There are no Vuex actions in this app —
// components own async logic — but Home, Browser, and Wishlist all need the
// same "populate listDeals / listStores from Supabase" behavior so a user can
// deep-link to any route on a cold visit.

// Fetch every deal from Supabase and commit both the flat list and the
// per-store arrays derived by grouping on storeID.
export async function loadDeals (store) {
  const allDeals = await supabase.fetchDeals()
  store.commit('listDeals', allDeals)

  const byStore = allDeals.reduce((acc, d) => {
    (acc[String(d.storeID)] = acc[String(d.storeID)] || []).push(d)
    return acc
  }, {})
  STORES_META.forEach(s => {
    store.commit(s.key, byStore[String(s.id)] || [])
  })
  return allDeals
}

// vuex-persistedstate restores the per-store arrays but not listDeals
// (persisting it would double the localStorage footprint). On a cache hit,
// rebuild the flat list from the restored per-store arrays.
export function rebuildListDeals (store) {
  const all = STORES_META.flatMap(s => store.state[s.key] || [])
  all.sort((a, b) => (parseFloat(b.dealRating) || 0) - (parseFloat(a.dealRating) || 0))
  store.commit('listDeals', all)
  return all
}

export async function ensureStoresLoaded (store) {
  if (store.state.listStores && store.state.listStores.length > 0) return store.state.listStores
  const stores = await supabase.fetchStores()
  if (stores && stores.length) store.commit('listStores', stores)
  return stores
}

// Deep-link entry points (Browser, Wishlist): make sure listDeals has data,
// preferring the persisted per-store arrays over a network round-trip.
export async function ensureDealsLoaded (store) {
  if (store.state.listDeals && store.state.listDeals.length > 0) return store.state.listDeals
  const restored = STORES_META.some(s => (store.state[s.key] || []).length > 0)
  if (restored) return rebuildListDeals(store)
  return loadDeals(store)
}
